import UserModel from '../models/UserModel';
import BaseStore from './BaseStore';
import {observable} from 'mobx';

export default class UserStore extends BaseStore {

  @observable permissions = [];

  constructor(transportLayer) {
    super(UserModel, transportLayer);
  }

  setUserPermissions(permissions){
    this.permissions = permissions;
  }
}



// WEBPACK FOOTER //
// ./src/stores/UserStore.js